var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPendingBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.48645 20 0 15.5143 0 10C0 4.48645 4.48645 0 10 0C15.5143 0 20 4.48645 20 10C20 15.5143 15.5143 20 10 20ZM10 1.54918C5.34004 1.54918 1.54918 5.34004 1.54918 10C1.54918 14.66 5.34004 18.4508 10 18.4508C14.66 18.4508 18.4508 14.6592 18.4508 10C18.4508 5.34004 14.66 1.54918 10 1.54918Z",
    fill: "#E0E0E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60026 12.0231L6.60997 10.0328L5.94653 10.6963L8.60026 13.35L14.2868 7.66343L13.6234 7L8.60026 12.0231Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingBadge);
export default __webpack_public_path__ + "static/media/pending-badge.258790cc588f351dc16ff15d79da6e63.svg";
export { ForwardRef as ReactComponent };